import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, User, LogOut, Package, Shield } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useCart } from '@/contexts/CartContext';
import { useState } from 'react';
import AuthModal from './AuthModal';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_petshop-seedlings/artifacts/d48ts1t7_civaie40.jpeg';

export default function Navbar() {
  const { user, logout } = useAuth();
  const { cartCount } = useCart();
  const [showAuth, setShowAuth] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <>
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
              <img 
                src={LOGO_URL} 
                alt="Civaie" 
                className="h-12 w-12 rounded-full object-cover"
              />
              <div className="text-2xl font-extrabold">
                <span className="text-rose-600">Civaie</span>
              </div>
            </Link>

            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/categories"
                className="text-gray-700 hover:text-rose-600 font-medium transition-colors"
                data-testid="products-link"
              >
                Prodotti
              </Link>
            </div>

            <div className="flex items-center gap-4">
              <Link to="/cart" className="relative" data-testid="cart-link">
                <Button variant="ghost" size="icon" className="relative">
                  <ShoppingCart className="h-5 w-5" />
                  {cartCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-rose-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
                      {cartCount}
                    </span>
                  )}
                </Button>
              </Link>

              {user ? (
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="icon" data-testid="user-menu-trigger">
                      <User className="h-5 w-5" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-48">
                    <div className="px-2 py-1.5 text-sm font-semibold">{user.name}</div>
                    <DropdownMenuItem onClick={() => navigate('/orders')} data-testid="orders-menu-item">
                      <Package className="mr-2 h-4 w-4" />
                      I miei ordini
                    </DropdownMenuItem>
                    {user.is_admin && (
                      <DropdownMenuItem onClick={() => navigate('/admin')} data-testid="admin-menu-item">
                        <Shield className="mr-2 h-4 w-4" />
                        Admin
                      </DropdownMenuItem>
                    )}
                    <DropdownMenuItem onClick={handleLogout} data-testid="logout-menu-item">
                      <LogOut className="mr-2 h-4 w-4" />
                      Esci
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              ) : (
                <Button
                  onClick={() => setShowAuth(true)}
                  className="bg-rose-600 hover:bg-rose-700 text-white rounded-full font-bold px-6"
                  data-testid="login-button"
                >
                  Accedi
                </Button>
              )}
            </div>
          </div>
        </div>
      </nav>
      <AuthModal open={showAuth} onClose={() => setShowAuth(false)} />
    </>
  );
}